globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.ButtonCollapsable = (function() {

  function ButtonCollapsable($button) {
    this.$button      = $button;
    this.targetClass  = this.$button.data("target");
    this.$target      = $(this.targetClass);
    this.$chevron     = this.$button.find("i.fa-chevron-down");
    this.init();
  }

  ButtonCollapsable.init = function($html) {
    $html.find(".collapse-btn").each(function(){
      new ButtonCollapsable($(this));
    })
  }

  ButtonCollapsable.prototype = {
    init: function() {
      var _this = this;

      _this.$button.on("click", function() {
        if(_this.$button.hasClass("animated-toggle")) {
          _this._toggleWithAnimation();
        } else {
          _this.$target.toggle();
        }

        _this.$chevron.toggleClass("fa-chevron-down fa-chevron-up");
      })
    },
    _toggleWithAnimation: function(){
      var _this = this;

      if(_this.$target.hasClass("open")) {
        _this.$target.slideUp(300).removeClass("open");
      } else {
        _this.$target.slideDown(300).addClass("open");
      }
    }
  }

  return ButtonCollapsable;

})();
